module.exports = __webpack_public_path__ + "static/cucina_high-97e4dd6c3603f358f7efbc71d7655c57.mp4";